import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { Component, Input, OnInit } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { ProductItem } from "../../../core/models/products.model";
import { ProductCatalogService } from "../../../core/services/product-catalog.service";
import { ProductService } from "../../../core/services/products.service";
import { SiilaTranslationService } from "../../../core/services/siila-translation.service";
import { I18nService } from "../../services";

@Component({
  selector: "app-market-analytic-card",
  templateUrl: "./market-analytic-card.component.html",
  styleUrls: ["./market-analytic-card.component.scss"]
})
export class MarketAnalyticCardComponent implements OnInit {
  @Input() includeMarketAnalyticsV1 = false;
  @Input() parentComp;
  currentCode: string;
  translatePath: string;
  marketCardTranslatePath: string;
  resourseTranslatePanth: string;
  checkList = [];
  marketCardList = [];
  marketImgCard: string[];
  products: ProductItem[];
  lang: string;
  isMobile = false;
  marketAnalyticsAltSolutions: string;

  constructor(
    private productService: ProductService,
    private productCatalog: ProductCatalogService,
    private siilaTranslationService: SiilaTranslationService,
    private i18: I18nService,
    public breakpointObserver: BreakpointObserver
  ) {
    this.lang = this.siilaTranslationService.getCurrentLanguage();
    this.currentCode = environment.platformId;
    this.checkList = [...Array(5).keys()].map(i => {
      this.translatePath = `products.${this.currentCode}.products.features-card.marketAnalytics.check-list.`;
      this.marketCardTranslatePath = `products.${this.currentCode}.products.features-card.marketAnalytics.card-list.`;
      this.resourseTranslatePanth = `products.${this.currentCode}.products.marketing-card.featuredResources.resources.card-list.`;
      return {
        icon: "assets/icons/check.svg",
        title: `${this.translatePath}check${i + 1}.title`,
        desc: `${this.translatePath}check${i + 1}.desc`
      };
    });

    this.marketImgCard = [
      "assets/img/products-list/indices.png",
      "assets/img/products-list/investors.png",
      "assets/img/products-list/grocs.png"
    ];

    this.breakpointObserver
      .observe([Breakpoints.HandsetPortrait, Breakpoints.HandsetLandscape])
      .subscribe(result => {
        this.isMobile = result.matches;
      });
  }

  ngOnInit(): void {
    this.marketAnalyticsAltSolutions = this.siilaTranslationService.getImgSEOTranslation(
      "solutions.marketanalyticsalt"
    );
    this.productService.getMarketAnalytics().subscribe(products => {
      this.products = products;
      this.marketCardList = products.map((item, index) => {
        return {
          id: item.id,
          background: this.marketImgCard[index],
          src: `${environment.cloudfrontURL}${item.iconPath}/360w/${item.iconFilename}`,
          iconAltTitle: this.findIconAltTitle(item),
          title: item.productShortName,
          text: item.menuItemDescription,
          actionText: item.menuItemActionButtonText
        };
      });
      if (this.currentCode == "mx") {
        var item = {
          id: 999,
          productShortName: '{"en":"FIBRA ANALYTICS","es":"FIBRA ANALYTICS"}',
          menuItemDescription:
            '{"en":"Exclusive access to real-time financial and real estate data for Mexican FIBRAS.","es":"Acceso exclusivo a datos financieros inmobiliarios en tiempo real para los FIBRAs Mexicanos."}',
          menuItemActionButtonText: '{"en":"LEARN MORE","es":"CONOCE MÁS"}',
          src: `assets/icons/corporate_fare.svg`,
          imgAltTitle: this.siilaTranslationService.getImgSEOTranslation(
            "cardicons.gross"
          )
        };
        var index = 2;

        this.marketCardList.push({
          id: item.id,
          background: this.marketImgCard[index],
          src: item.src,
          iconAltTitle: item.imgAltTitle,
          title: item.productShortName,
          text: item.menuItemDescription,
          actionText: item.menuItemActionButtonText
        });
      }
    });
  }

  findIconAltTitle = (item: { id: number }) => {
    let card = "imgSEO.cardicons.";
    if (item.id == 101 || item.id === 106) {
      card += "gross";
    } else if (item.id == 102 || item.id === 107 || item.id === 104) {
      card += "index";
    } else {
      card += "investorsurvey";
    }
    return this.siilaTranslationService.getTranslationFromJSONFiles(card);
  };

  openTarted() {
    window.open(
      this.i18.buildLocalizedPath(
        `${environment.applicationURL}/marketanalytics`
      ),
      this.isMobile ? "_self" : "_blank"
    );
  }

  openInfoCard(card: { id: number; title: string }) {
    if (card.id == 999) {
      window.open(
        this.i18.buildFibraAnalyticsUrl(),
        this.isMobile ? "_self" : "_blank"
      );
    } else {
      // The URL comes from `ProductCatalogService`, never from the CMS record: an
      // in-page card must not link at a spelling the header, footer and sitemap do
      // not carry. Falls back to the previous derivation for an id the catalog
      // does not publish, so a stray CMS record still opens something.
      const path =
        this.productCatalog.buildPathForId(card.id) ||
        this.i18.buildLocalizedPath(
          `/products/${card.id}/${this.i18.getTranslation(card.title)}`
        );
      window.open(path, this.isMobile ? "_self" : "_blank");
    }
  }

  imgMarketAnalyticsAlt() {
    if (!this.parentComp) {
      return this.siilaTranslationService.getTranslationFromJSONFiles(
        "imgSEO.macpic"
      );
    }

    if (
      this.parentComp == "solutions101" ||
      this.parentComp == "solutions111" ||
      this.parentComp == "solutions103" ||
      this.parentComp == "solutions110" ||
      this.parentComp == "solutions104" ||
      this.parentComp == "solutions108" ||
      this.parentComp == "solutions115" ||
      this.parentComp == "solutions117" ||
      this.parentComp == "solutions118"
    ) {
      return this.marketAnalyticsAltSolutions;
    }

    if (
      this.parentComp == "solutions102" ||
      this.parentComp == "solutions109" ||
      this.parentComp == "solutions116"
    ) {
      return this.siilaTranslationService.getImgSEOTranslation(
        "brokerage.details"
      );
    }

    if (
      this.parentComp == "solutions105" ||
      this.parentComp == "solutions119"
    ) {
      return this.siilaTranslationService.getImgSEOTranslation(
        "valuationAdvisor.details"
      );
    }

    if (this.parentComp == "solutions112") {
      return this.siilaTranslationService.getImgSEOTranslation(
        "fiiInvestors.benefits.4"
      );
    }

    if (
      this.parentComp == "solutions106" ||
      this.parentComp == "solutions113" ||
      this.parentComp == "solutions120"
    ) {
      return this.siilaTranslationService.getImgSEOTranslation(
        "serviceProvider.details"
      );
    }

    if (
      this.parentComp == "solutions107" ||
      this.parentComp == "solutions122" ||
      this.parentComp == "solutions114"
    ) {
      return this.siilaTranslationService.getImgSEOTranslation(
        "fiiInvestors.details"
      );
    }
  }

  imgMarketAnalytics() {
    let img = "../../../../../assets/img/products-list/";
    if (
      this.currentCode == "mx" ||
      this.currentCode == "co" ||
      this.currentCode == "latam"
    ) {
      if (this.lang == "en") {
        img = img + "item-2-mockup SiiLA-EN-MX.png";
      } else {
        img = img + "item-2-mockup SiiLA-ES.png";
      }
    } else {
      if (this.lang == "en") {
        img = img + "item-2-mockup SiiLA-EN-BR.png";
      } else {
        img = img + "item-2-mockup SiiLA-PT.png";
      }
    }

    return img;
  }
}
